import { styled } from '@mui/system';

export const StyledModal = styled('Modal')(({ theme }) => ({
    '&.graph-edit-modal': {
      outline: 'none',
    },
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(460px, calc(100vw - 24px))',
    height: 'min(90dvh, 720px)',
    minHeight: 'min(500px, calc(100dvh - 24px))',
    maxHeight: 'calc(100dvh - 24px)',
    backgroundColor: theme.palette.background.paper, // Fix bgcolor to backgroundColor
    boxShadow: theme.shadows[24], // Use theme.shadows array for boxShadow
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '14px',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      inset: 0,
      top: 0,
      left: 0,
      transform: 'none',
      width: '100vw',
      height: '100dvh',
      minHeight: '100dvh',
      maxHeight: '100dvh',
      borderRadius: 0,
      boxShadow: 'none',
      animation: 'graphTakeoverSlideUp 220ms cubic-bezier(0.2, 0, 0, 1)',
    },
    '@keyframes graphTakeoverSlideUp': {
      from: {
        transform: 'translateY(100%)',
      },
      to: {
        transform: 'translateY(0)',
      },
    },
  }))

export const StyledModalInnerWrapper = styled('Box')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: 0,
  }))

export const StyledModalHeader = styled('Box')(({ theme, headerBackgroundColor }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    alignItems: 'center',
    width: '100%',
    height: 'auto',
    minHeight: 'min(210px, 30dvh)', // Fix duplicate height and minHeight
    padding: '16px 12px',
    borderBottom: '1px solid #000',
    backgroundColor: headerBackgroundColor || theme.palette.secondary.main,
    justifyContent: 'center',
    spacing: '10px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      minHeight: 'auto',
      padding: 'max(10px, env(safe-area-inset-top)) 14px 10px',
      gap: '8px',
      position: 'relative',
      '&.graph-modal-header--compact': {
        padding: 'max(8px, env(safe-area-inset-top)) 14px 8px',
      },
    },
  }))

export const StyledModalBody = styled('Box')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    overflow: 'auto',
    padding: '16px',
    boxSizing: 'border-box',
    WebkitOverflowScrolling: 'touch',
    flex: '1 1 auto',
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      padding: '16px 12px',
      gap: '12px',
      overscrollBehavior: 'contain',
      '& .MuiInputBase-root': {
        minHeight: 48,
      },
      '& .MuiInputBase-input': {
        fontSize: 16,
      },
      '& .MuiTextField-root textarea': {
        minHeight: '96px',
      },
    },
  }))

export const StyledModalFooter = styled('Box')(({ theme, headerBackgroundColor }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: '8px',
    padding: '12px',
    marginTop: 'auto',
    width: '100%',
    borderTop: '1px solid #000',
    backgroundColor: headerBackgroundColor || theme.palette.secondary.main,
    boxSizing: 'border-box',
    flexShrink: 0,
    '& > button': {
      minHeight: 40,
      flex: '1 1 118px',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'sticky',
      bottom: 0,
      padding: '10px 12px max(12px, env(safe-area-inset-bottom))',
      gap: '8px',
      justifyContent: 'stretch',
      '& > button': {
        minHeight: 46,
        flex: '1 1 100%',
        fontSize: 15,
      },
    },
  }))
